// extracted by mini-css-extract-plugin
export default {"container":"InfoIcon_container__3BpvQ","icon":"InfoIcon_icon__nbNtQ"};